import ApiService from "./api_service";
export default class DeleteMemberScaleModule {
  constructor(controller) {
    this.controller = controller;
    this.apiService = new ApiService();
  }

  initialize() {
    this.initDeleteMemberScale();
  }

  initDeleteMemberScale() {
    this.controller.deleteMemberScaleTargets.forEach((deleteMemberScale) => {
      const memberScaleId = deleteMemberScale.dataset.memberScaleId;
      deleteMemberScale.addEventListener("click", () => {
        if (confirm("Tem certeza que deseja remover este integrante?")) {
          this.apiService.deleteMember(memberScaleId).then(() => {
            deleteMemberScale.closest("li").remove();
          });
        }
      });
    });
  }
}
